// ProductDetailsModal.jsx
import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ProductDetails from "./index"; // reuse your details component
import "./style.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

export default function ProductDetailsModal() {
  const navigate = useNavigate();
  const location = useLocation();
  const { store_id, menu_id } = useParams();

  const close = () => {
    if (location.state?.backgroundLocation) {
      navigate(-1);
    } else {
      navigate("/menu", { replace: true });
    }
  };

  useEffect(() => {
    // Lock scroll
    document.body.style.overflow = "hidden";

    return () => {
      // Restore scroll when modal unmounts
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="modal-overlay" onClick={close}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <Header />
        <ProductDetails isModal={true} />
        <Footer />
      </div>
    </div>
  );
}
